// import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
// import React, { useState } from 'react';

// const CheckoutForm = () => {
//   const [success, setSuccess] = useState(false);
//   const stripe = useStripe();
//   const elements = useElements();
//   const appearance = {
//     theme: 'stripe'
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!stripe || !elements) {
//       return;
//     }

//     const result = await stripe.confirmPayment({
//       elements,
//       confirmParams: {
//         return_url: "https://example.com/order/123/complete",
//       },
//     });

//     if (result.error) {
//       console.log(result.error.message);
//     } else {
//       setSuccess(true);
//     }
//   };

//   return (
//     <>
//     {!success ?       <form onSubmit={handleSubmit}>
//         <PaymentElement options={{ appearance }} />
//         <button disabled={!stripe}>Submit</button>
//       </form> : <h2>Your purchase has been completed!</h2> }

//     </>
//   )
// };

// export default CheckoutForm;


// import React, { useState } from 'react';
// import { CardElement, useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';

// const CheckoutForm = () => {
//   const [error, setError] = useState(null);
//   const stripe = useStripe();
//   const elements = useElements();
//   const appearance = {
//     theme: 'stripe'
//   };
//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     const result = await stripe.createToken(elements.getElement(CardElement));
//     if (result.error) {
//       setError(result.error.message);
//     } else {
//       // handle successful token creation
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit}>
//       <label>
//         Card details
//         <PaymentElement />
//       </label>
//       <button type="submit" disabled={!stripe}>
//         Pay
//       </button>
//       {error && <div>{error}</div>}
//     </form>
//   );
// };

// export default CheckoutForm;
import React, { useEffect, useState } from "react";
import {
  PaymentElement,
  LinkAuthenticationElement,
  useStripe,
  useElements
} from "@stripe/react-stripe-js";

import styled from "styled-components";

export default function CheckoutForm() {
  const stripe = useStripe();
  const elements = useElements();

  const [email, setEmail] = useState('');
  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!stripe) {
      return;
    }

    const clientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );

    if (!clientSecret) {
      return;
    }

    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      switch (paymentIntent.status) {
        case "succeeded":
          setMessage("Payment succeeded!");
          break;
        case "processing":
          setMessage("Your payment is processing.");
          break;
        case "requires_payment_method":
          setMessage("Your payment was not successful, please try again.");
          break;
        default:
          setMessage("Something went wrong.");
          break;
      }
    });
  }, [stripe]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsLoading(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        // Make sure to change this to your payment completion page
        return_url: "http://localhost:3000",
      },
    });

    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.
    if (error.type === "card_error" || error.type === "validation_error") {
      setMessage(error.message);
    } else {
      setMessage("An unexpected error occurred.");
    }

    setIsLoading(false);
  };

  const paymentElementOptions = {
    layout: "tabs"
  }

  return (
    <StyledForm id="payment-form" onSubmit={handleSubmit}>
      <LinkAuthenticationElement
        id="link-authentication-element"
        onChange={(e) => setEmail("bob@bob.com")}
      />
      <PaymentElement id="payment-element" options={paymentElementOptions} />
      <button disabled={isLoading || !stripe || !elements} id="submit">
        <span id="button-text">
          {isLoading ? <div className="spinner" id="spinner"></div> : "Pay now"}
        </span>
      </button>
      {/* Show any error or success messages */}
      {message && <div id="payment-message">{message}</div>}
    </StyledForm>
  );
}



const StyledForm = styled.form`
width: 50%;
margin: auto;
`